<div class="notifications-container">
<!--  <button mat-stroked-button color="primary" (click)="goBack()" class="float-end">-->
<!--    <mat-icon>arrow_back</mat-icon>-->
<!--    Back-->
<!--  </button>-->
  <h2>All Notifications</h2>
  <!-- Search & Date Range -->
  <div class="row">
    <mat-form-field appearance="outline" class="col-md-6">
      <mat-label>Search</mat-label>
      <input matInput placeholder="Search notifications..." [(ngModel)]="searchTerm" (keyup)="applyFilters()">
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>Start Date</mat-label>
      <input matInput [matDatepicker]="picker1" [(ngModel)]="startDate" (dateChange)="applyFilters()">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-3">
      <mat-label>End Date</mat-label>
      <input matInput [matDatepicker]="picker2" [(ngModel)]="endDate" (dateChange)="applyFilters()">
      <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field>
  </div>

  <!-- Grouped Notifications -->
  <div *ngFor="let group of filteredGrouped">
    <div class="date-divider">{{ group.date }}</div>

    <div *ngFor="let n of group.items"
         class="notification-card"
         [class.unread]="n.status === 'msg-unread'"
         (click)="handleClick(n)">

      <mat-icon class="icon" [style.color]="n.color">{{ n.icon }}</mat-icon>

      <div class="content">
        <div class="message">{{ n.message }}</div>
        <div class="time">{{ getTimeAgo(n.time) }}</div>
      </div>

      <div class="actions">
        <button mat-icon-button color="primary" (click)="markAsRead(n); $event.stopPropagation()">
          <mat-icon>done_all</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="deleteNotification(n); $event.stopPropagation()">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <mat-paginator
    [length]="totalNotifications"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 20]"
    (page)="onPageChange($event)"
    showFirstLastButtons>
  </mat-paginator>


</div>
